import Swal from "sweetalert2";
import { IRelatorio } from "../../interfaces/IRelatorio";
import { useDrag } from 'react-dnd';
import { useState } from "react";

const Cartao = ({ data, showModal, onShowPreview, updateCard }: { data: IRelatorio, showModal: Function, onShowPreview: Function, updateCard: Function }) => {

    const [loadingReport, setLoadingReport] = useState<boolean>(false);

    const [{ opacity }, dragRef] = useDrag(() => ({
        type: 'CARD',
        item: { id: data.id, codigo: data.contaEmpresa, status: data.status, isContaConciliacaoInteligente: data.contaConciliacaoInteligente, isBanco: data.isBanco, isSalario: data.isSalario, isFornecedor: data.isFornecedor },
        collect: (monitor) => ({
            opacity: monitor.isDragging() ? 0.5 : 1,
        })
    }), []);

    return (
        <div onClick={() => {
            if (data.status && data.status !== "Pendentes" && data.status !== "Em processamento") {
                showModal(data.contaEmpresa, data.id);
            } else {
                Swal.fire({
                    text: 'Não é possível abrir contas Pendentes ou Em processamento!!',
                    timer: 3000,
                    icon: 'error',
                    showConfirmButton: false
                });
            }
        }} ref={dragRef} style={{ opacity, width: '100%', height: 'auto', backgroundColor: '#EBECF0', padding: '10px 5px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'start', width: '100%', backgroundColor: data.destacar ? 'rgba(192, 57, 43, 0.1)' : 'white', borderRadius: '2px', padding: '5px' }}>
                <p style={{ fontSize: '14px', color: '#172b4d', margin: '0', textAlign: 'justify' }}>{data.contaEmpresa} - {data.descricaoEmpresa || data.descricaoReferencial}</p>
                {loadingReport ? (
                    <div className="spinner-border text-success" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                ) : (
                    <div style={{ display: 'flex' }}>
                        {(data.porcentagemConciliado != null) && <label className="mt-1" style={{ marginLeft: '5px' }}>{data.porcentagemConciliado}%</label>}
                    </div>
                )}
            </div>
        </div>
    );
}

export default Cartao;